// WHICH OF THE TWO LOT PHOTOS THE FORM WILL NOT POST WITHOUT (2026-10-31).
//
// Sandra Price, White Lotus Body Arts Studio (Ventura, CA), by email on 2026-10-30: "can you make it mandatory that
// they cannot submit the form without doing the photo of the needle cartridge, we keep getting clients submitting the
// form before that is put in. And in our area, having that in is super important." Chris, that evening: "I'll be able to
// get that done either tomorrow or Monday morning."; and the next morning, on the shape: "make this required" · "i could
// see it defaulting to required to protect the customer and then "make this optional" being a thing."
//
// Both photos have been OPTIONAL since 2026-09-10, on the page and at the door, because two photo fields once stood
// between a client who had signed and a finished waiver (Chris: "We should never have it so if someone signs and fills
// out everything they can't finish"). That rule still holds for every shop that never asked: a photo is required only
// where the shop's own row says so (`public_data.lot_photos_required`, {needle, ink}; the shop app writes both true when
// the ask is turned on from today, and the owner unticks "Required" to make one optional; a shop whose ask was on before
// keeps its photos optional until its owner ticks a box). What makes the wall a step is that a refusal TAKES the client to
// the box (refusal.ts, since 2026-09-29): the sentence names which photo, and the page scrolls its spot to the middle.
//
// The API refuses the same body (app.py NEEDLE_PHOTO_MISSING / INK_PHOTO_MISSING), with the same two sentences in the
// language signed. This file is the pure half: what the shop requires, and which photo a submit is missing.

export type LotPhotoKind = "needle" | "ink";

/** The two, in page order: the needle pack's spot sits above the ink's. */
export const LOT_PHOTO_KINDS: readonly LotPhotoKind[] = ["needle", "ink"];

export type RequiredLotPhotos = Record<LotPhotoKind, boolean>;

export const NEITHER_REQUIRED: RequiredLotPhotos = { needle: false, ink: false };

/** The shop's own map, read as the form reads every public setting: a literal true is required, anything else is not.
 *  Pass `undefined` while the ask itself is off, and neither is required whatever the map says. */
export function requiredLotPhotosOf(raw: unknown): RequiredLotPhotos {
  const map = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  return { needle: map.needle === true, ink: map.ink === true };
}

/** A photo the page holds: the uploader's data URL, or nothing. A string with no bytes after its comma is no photo,
 *  the API's own reading of a posted photo (app.py lot_photo_present). */
export function hasLotPhoto(value: unknown): boolean {
  if (typeof value !== "string") return false;
  const comma = value.indexOf(",");
  return comma >= 0 && value.slice(comma + 1).trim().length > 0;
}

/** The first required photo a submit is missing, in page order, or null when nothing required is missing. */
export function missingLotPhoto(
  required: RequiredLotPhotos,
  photos: Partial<Record<LotPhotoKind, unknown>>
): LotPhotoKind | null {
  for (const kind of LOT_PHOTO_KINDS) {
    if (required[kind] && !hasLotPhoto(photos[kind])) return kind;
  }
  return null;
}
